import script from "./DocumentaryRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentaryRecord.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentaryRecord.vue?vue&type=style&index=0&id=ee989128&lang=scss&scoped=true"
import "./DocumentaryRecord.vue?vue&type=style&index=1&id=ee989128&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee989128"]])

export default __exports__